/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input, OnChanges, SimpleChanges, TemplateRef} from '@angular/core';
import template from './admin-resource-list-shell.component.html';

import {AdminListColumn, AdminResourceListPageBase} from '../controller/admin-resource-list-page-base';
import {AdnResourceListService} from '../controller/adn-resource-list.service';

@Component({
  standalone: false,
  selector: 'adn-admin-resource-list-shell',
  template
})
export class AdminResourceListShellComponent implements OnChanges {
  @Input() page: AdminResourceListPageBase;
  @Input() columns: AdminListColumn[];
  @Input() emptyMessage: string;
  @Input() enableBulkSelection = true;
  @Input() rowTemplate: TemplateRef<any>;
  /** When true, parent supplies the full bulkActionHolder via [bulkActionHolder] projection. */
  @Input() customBulkActionHolder = false;

  sortHeaderParams: AdminListColumn[] = [];

  constructor(private readonly listService: AdnResourceListService) {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.page || changes.columns) {
      this.syncSortHeaderParams();
      this.wireList();
    }
  }

  private syncSortHeaderParams(): void {
    const dynamicParams = this.page?.sortHeaderParams;
    this.sortHeaderParams = dynamicParams?.length ? dynamicParams : (this.columns || []);
  }

  private wireList(): void {
    if (this.page?.list) {
      this.listService.ensureAngularList(this.page.list);
    }
  }
}
